import React from 'react';
import { Plane, Bus, Users } from 'lucide-react';
import WeeklyChart from './WeeklyCard';
import TopDestinations from './TopDescription';
export default function Statistics() {
  const stats = [
    {
      title: "Voyages Aujourd'hui",
      value: "124",
      increase: "+12.5%",
      icon: <Plane className="w-12 h-12 text-brand-600" />,
      details: "85 entrées | 39 sorties"
    },
    {
      title: "Passagers Total",
      value: "1,234",
      increase: "+5.2%",
      icon: <Users className="w-12 h-12 text-green-500" />,
      details: "842 internationaux | 392 nationaux"
    },
    {
      title: "Transports Actifs",
      value: "45",
      increase: "+8.7%",
      icon: <Bus className="w-12 h-12 text-blue-500" />,
      details: "28 aériens | 17 routiers"
    }
  ];

  return (
    <div className="mb-12">
      <h2 className="text-3xl font-bold mb-8"></h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow"
          >
            <div className="flex justify-between items-start">
              <div>
                <p className="text-gray-500 dark:text-gray-400 text-sm font-medium mb-1">
                  {stat.title}
                </p>
                <div className="flex items-baseline">
                  <h3 className="text-3xl font-bold">{stat.value}</h3>
                  <span className="ml-2 text-sm font-medium text-green-500">
                    {stat.increase}
                  </span>
                </div>
                <p className="text-gray-600 dark:text-gray-400 text-sm mt-2">
                  {stat.details}
                </p>
              </div>
              <div className="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                {stat.icon}
              </div>
            </div>

            {/* Barre de progression */}
            {/* <div className="mt-4">
              <div className="flex justify-between items-center mb-1">
                <span className="text-sm text-gray-500 dark:text-gray-400">Progression</span>
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300">78%</span>
              </div>
              <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-brand-500 to-green-500 rounded-full"
                  style={{ width: '78%' }}
                />
              </div>
            </div> */}

            {/* Mini graphique */}
            <div className="mt-4 flex justify-between items-end h-8">
              {[35, 45, 32, 47, 42, 38, 45].map((value, i) => (
                <div
                  key={i}
                  className="w-6 bg-brand-100 dark:bg-brand-900/20 rounded-t"
                  style={{ height: `${value}%` }}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};



// Vous pouvez également ajouter ces composants supplémentaires pour plus de statistiques détaillées
const DetailedStats = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-12">
      <WeeklyChart />
      <TopDestinations />
    </div>
  );
};